import { render, staticRenderFns } from "./AdoptionFile.vue?vue&type=template&id=45297636&scoped=true"
import script from "./AdoptionFile.vue?vue&type=script&lang=js"
export * from "./AdoptionFile.vue?vue&type=script&lang=js"
import style0 from "./AdoptionFile.vue?vue&type=style&index=0&id=45297636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45297636",
  null
  
)

export default component.exports